import { useEffect, useState } from "react";
import { useEventDataOfSelectedEvent } from "@Utils";
import { useSetSlots } from "@Modules/eventPage/utils/useSetSlots";
import { IEvent } from "@Interfaces";
import { getWorkshopSlots } from "@Modules/eventPage/utils/getWorkshopSlots";
import { parseDateTime } from "@Utils/parseDateTime";

const useWorkshopSchedule = () => {
    const { eventData } = useEventDataOfSelectedEvent();
    const setSlots = useSetSlots();

    // Is the creator description expanded or not
    const [isExpanded, setExpanded] = useState<boolean>(false);

    const hideSessionTitle: boolean =
        !!eventData?.metadata?.no_workshop_session_title;

    useEffect(() => {
        // Load up the slots from the API data into the root component react hook state
        if (eventData?.slots) {
            setSlots(getWorkshopSlots(eventData?.slots));
        }
    }, [eventData]);
    const slotTitle = (slot: IEvent.ISlot) =>
        hideSessionTitle
            ? parseDateTime(slot.start_time, "E MMM dd yyyy")
            : slot.title;
    const showMore = eventData?.slots?.length > 5;

    // since workshop schedule is shown as textual details, we hide it in case of `eventMetadata.hide_creator_detail`
    // but we still want to execute the business logic so that slots are sent in payment payload
    const hideComponent = eventData?.metadata?.hide_creator_detail;

    return {
        eventData,
        isExpanded,
        slotTitle,
        setExpanded,
        hideSessionTitle,
        showMore,
        hideComponent,
    };
};

export default useWorkshopSchedule;
